import React from 'react';
import PropTypes from 'prop-types';

import { nl2br } from 'utils';

import Modal from 'components/modal';

export default class ConfirmModal extends React.PureComponent {
  static contextTypes = {
    closeModal: PropTypes.func.isRequired,
  };

  static propTypes = {
    title: PropTypes.node,
    message: PropTypes.any,
    action: PropTypes.string,
    actionType: PropTypes.string,
    extraActions: PropTypes.array,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    cancel: PropTypes.bool,
    cancelText: PropTypes.string,
    loadingTitle: PropTypes.string,
    width: PropTypes.number,
    actionHidden: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: props.loading || false,
    };
  }

  eventController = null;

  componentDidMount() {
    this.eventController = new AbortController();
    document.addEventListener('keydown', this.onKeyDown.bind(this), {
      signal: this.eventController.signal,
    });
  }

  componentWillUnmount() {
    if (this.eventController) {
      this.eventController.abort();
    }
  }

  onKeyDown = (event) => {
    switch (event.keyCode) {
      case 13: // enter
        this.onClickConfirm(event);
        break;
      case 27: // escape
        this.onClickCancel(event);
        break;
      default:
    }
  };

  onClickConfirm = (event) => {
    this.confirm(event, this.props.onConfirm);
  };

  confirm(event, onConfirm) {
    event.preventDefault();
    if (onConfirm) {
      const result = onConfirm();

      if (result && typeof result.then === 'function') {
        this.setState({ loading: true });
      }

      Promise.resolve(result)
        .then((result) => {
          if (result !== false) {
            this.context.closeModal();
          } else {
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false });
        });
    } else {
      this.context.closeModal();
    }
  }

  // Extra actions with `onConfirm` are confirmed like the main action
  getExtraActions() {
    return (this.props.extraActions || []).map((act) => {
      if (!act?.onConfirm) {
        return act;
      }

      const { onConfirm, ...action } = act;

      return {
        ...action,
        onClick: (event) => this.confirm(event, onConfirm),
      };
    });
  }

  onClickCancel = (event) => {
    event.preventDefault();
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.context.closeModal();
  };

  render() {
    const {
      title = 'Confirmation',
      message = "Are you sure? This action can't be undone",
      action = 'Confirm',
      actionType = 'default',
      actionHidden = false,
      cancelText = 'Cancel',
      extraActions,
      cancel = true,
      width,
      loadingTitle,
      ...modalProps
    } = this.props;

    return (
      <Modal
        title={title}
        className="modal-confirm"
        actions={[
          actionHidden
            ? null
            : { label: action, type: actionType, onClick: this.onClickConfirm },
          ...this.getExtraActions(),
          !!cancel && {
            label: cancelText,
            type: 'cancel',
            onClick: this.onClickCancel,
          },
        ]}
        width={width}
        onClose={this.onClickCancel}
        cancel={false}
        closable={true}
        tapout={true}
        loadingTitle={loadingTitle}
        {...modalProps}
        loading={this.state.loading}
      >
        {typeof message === 'string' ? <p>{nl2br(message)}</p> : message}
      </Modal>
    );
  }
}
